import { fetchWallets } from '../../api/wallets.js';
import { appState } from '../../store/appState.js';

// Hàm Render (Vẽ) danh sách Ví ra màn hình
export async function renderWalletsTab() {
    const walletsList = document.getElementById('wallets-list');
    if(!walletsList) return;
    
    walletsList.innerHTML = '<p class="text-center text-gray-500 mt-4"><i class="fa-solid fa-spinner fa-spin"></i> Loading wallets...</p>';

    const wallets = await fetchWallets();
    walletsList.innerHTML = '';
    
    if(!wallets || wallets.length === 0) return;

    wallets.forEach(w => {
        // Map icon tương ứng với loại ví
        const icons = { cash: 'fa-money-bill-wave', bank: 'fa-building-columns', invest: 'fa-chart-line', other: 'fa-wallet' };
        const iconClass = icons[w.type] || 'fa-wallet';

        // Format số dư gốc
        const balanceFormatted = Number(w.balance).toLocaleString('en-US');
        let displayBalance = `${balanceFormatted} <span class="text-xs text-gray-400">${w.currency}</span>`;
        let vndEquivalent = '';

        // Nếu là Ngoại tệ -> Tính toán và hiển thị dòng quy đổi nhỏ bên dưới
        if (w.currency !== 'VND') {
            const rate = appState.exchangeRatesCache[w.currency] || 0;
            const currentBalanceVND = Number(w.balance) * rate;
            vndEquivalent = `<div class="text-[10px] text-gray-500 mt-1">~ ${Math.round(currentBalanceVND).toLocaleString('en-US')} VND</div>`;
        }

        const card = document.createElement('div');
        card.className = 'bg-cardbg border border-gray-700 p-4 rounded-xl flex justify-between items-center shadow-sm mb-3 cursor-pointer hover:bg-gray-800 transition';
        card.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('openWalletDetail', { detail: w }));
        });
        card.innerHTML = `
            <div class="flex items-center space-x-4">
                <div class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-primary text-lg">
                    <i class="fa-solid ${iconClass}"></i>
                </div>
                <div>
                    <div class="font-bold text-white text-sm">${w.name}</div>
                    <div class="text-[10px] text-gray-500 uppercase tracking-wider">${w.type}</div>
                </div>
            </div>
            <div class="text-right">
                <div class="font-bold text-white">${displayBalance}</div>
                ${vndEquivalent}
            </div>
        `;
        walletsList.appendChild(card);
    });
}
